<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">{{ pageTitle }}</h1>
          <p class="view-header__subtitle">Registrá entradas, salidas y transferencias entre depósitos.</p>
        </div>
        <div class="view-header__actions">
          <button v-if="selectedProduct" type="button" class="btn view-header__btn" @click="clearProductFilter">
            <i class="bi bi-x-lg"></i>
            Limpiar filtro
          </button>
          <button type="button" class="btn view-header__btn" @click="openModalTrans">
            <i class="bi bi-arrow-left-right"></i>
            Transferencia entre depósitos
          </button>
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="openModal">
            <i class="bi bi-arrow-down-up"></i>
            Nuevo movimiento
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL MOVIMIENTOS -->
    <NuevoMovimientoStock
      v-if="isModalVisible"
      :productId="effectiveProductId"
      :prodId="effectiveProductId"
      @confirmsavemovement="modalSucess()"
      @close="close()"
    />
    <!-- MODAL TRANSFERENCIA -->
    <MovimientoEntreSucursales
      v-if="isModalVisibleTrans"
      :productId="effectiveProductId"
      @confirmsavemovement="modalSucess()"
      @close="close()"
    />

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-funnel"></i>
          Filtros
        </div>
        <div v-if="!selectedProduct" class="filters-panel__row">
          <div class="filters-panel__field">
            <q-select v-model="filters.provider_id" :options="providerFilterOptions" placeholder="- Proveedor -" searchable />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="filters.brand_id" :options="brandFilterOptions" placeholder="- Marca -" searchable />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="filters.category_id" :options="categoryFilterOptions" placeholder="- Categoría -" searchable />
          </div>
          <div class="filters-panel__field">
            <q-select v-model.number="filters.active" :options="activeFilterOptions" />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="filters.qwarehouse" :options="warehouseFilterOptions" placeholder="- Todos los Depósitos -" searchable />
          </div>
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Movimiento:</label>
            <q-select v-model="movement_type" :options="movementTypeOptions" />
          </div>
          <div class="filters-panel__field filters-panel__field--inline text-left">
            <label class="control-label">Fecha:</label>
            <Daterange
              :key="daterangeKey"
              :opendir="'left'"
              :filtered="true"
              @datepicked="dateUpdated"
            />
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn filters-panel__btn--outline" @click="clearFilters()">
              <i class="bi bi-eraser"></i>
              Limpiar filtros
            </button>
          </div>
        </div>
      </div>

      <div v-if="!selectedProduct" class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador de producto
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field filters-panel__field--wide">
            <typeahead
              :name="'productFilter'"
              :placeh="'Filtrar por producto o codigo de fabrica'"
              :clean-on="true"
              :externalsrc="'/api/products/searchProducts'"
              @choosed="onProductSelected"
            />
          </div>
          <div class="filters-panel__field">
            <input v-model="filters.qcode" type="search" class="form-control" placeholder="Código interno (Enter)" @keyup.enter="lookupByCode">
          </div>
          <div class="filters-panel__field">
            <input v-model="filters.qmanufacturercode" type="search" class="form-control" placeholder="Código de fábrica (Enter)" @keyup.enter="lookupByManufacturerCode">
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import NuevoMovimientoStock from "./Nuevo-movimiento-de-stock.vue";
import MovimientoEntreSucursales from "./Movimiento-entre-sucursales.vue";
import Daterange from '../../global/Daterange-component.vue';
import typeahead from '../../global/Typeahead.vue';
import QSelect from '@/components/shared/QSelect.vue';
import { mapState } from "vuex";

export default {
  props: ['productIdParent'],
  components: {
    VdtnetTable,
    NuevoMovimientoStock,
    MovimientoEntreSucursales,
    Daterange,
    typeahead,
    QSelect,
  },
  data: function() {
    return {
      isModalVisibleTrans: false,
      isModalVisible: false,
      filters: {
        qname: '',
        qcode: '',
        qbarcode: '',
        qmanufacturercode: '',
        qwarehouse: null,
        page: 1,
        itemsPerPage: 15,
        active: 1,
        provider_id: null,
        brand_id: null,
        category_id: null,
        sorting: {
          col: '',
          order: 'desc'
        }
      },
      movement_type: 'all',
      daterange: {
        fromDate: null,
        toDate: null
      },
      doSearch: '',
      isLoading: false,
      suppressReload: false,
      daterangeKey: 0,
      showNewMovement: true,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/movements/list",
          type: "GET",
          data: (d) => {
            d.movement_type = this.movement_type;
            d.daterange = this.daterange;
            d.product_id = this.effectiveProductId;
            d.warehouse_id = this.filters.qwarehouse || 0;
            d.filters = this.filters;
            return d.data;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: true,
        pageLength: 15,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        order: [[0, 'desc']],
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        autoWidth: false,
      },
      fields: {
        created_at: {
          label: "Fecha y hora",
          defaultOrder: 'desc',
          render: (data) => data ? this.moment.utc(data).local().format('DD/MM/YYYY HH:mm:ss') : '',
        },
        code: {
          label: "Codigo Int.",
          render: (data, type, row) => {
            const code = data
              ? `<span class="data-table__primary" title="Codigo Interno"><i class="bi bi-hash"></i>${data}</span>`
              : "";
            const barcode = row.barcode
              ? `<small class="data-table__muted" title="Codigo de barra"><i class="bi bi-upc-scan mr-1"></i>${row.barcode}</small>`
              : "";
            const mfr = row.manufacturer_code
              ? `<small class="data-table__muted" title="Codigo de fabrica"><i class="bi bi-box-seam mr-1"></i>${row.manufacturer_code}</small>`
              : "";
            return `<div class="d-flex flex-column">${code}${barcode}${mfr}</div>`;
          },
        },
        product: { label: "Producto" },
        reference_id: { label: "Tipo" },
        mov: {
          label: "Movimiento",
          render: (data) => {
            const mod = data === "Ingreso" ? "status-badge--success" : "status-badge--danger";
            return `<span class="status-badge ${mod}">${data || ""}</span>`;
          },
        },
        quantity: { label: "Cantidad" },
        warehouse: { label: "Deposito" },
      },
      selectedProduct: null,
    };
  },
  computed: {
    ...mapState("categories", { categories: (state) => state.categories }),
    ...mapState("warehouse", { warehouse: (state) => state.warehouse }),
    ...mapState("brands", { brands: (state) => state.brands }),
    ...mapState("providers", { providers: (state) => state.providers }),
    providerFilterOptions() {
      return [{ value: 'Sin proveedor', label: 'Sin Proveedor' }, ...this.providers.map(provider => ({ value: provider.id, label: provider.name }))];
    },
    brandFilterOptions() {
      return [{ value: 'Sin marca', label: 'Sin Marca' }, ...this.brands.map(brand => ({ value: brand.id, label: brand.name }))];
    },
    categoryFilterOptions() {
      return this.categories.map(category => ({ value: category.id, label: category.name }));
    },
    warehouseFilterOptions() {
      return (Array.isArray(this.warehouse) ? this.warehouse : []).map(w => ({ value: w.id, label: w.name }));
    },
    activeFilterOptions() {
      return [
        { value: 0, label: 'Todos los productos' },
        { value: 1, label: 'Productos activos' },
        { value: 2, label: 'Productos inactivos' },
      ];
    },
    pageTitle() {
      return this.selectedProduct
        ? `Movimientos de ${this.selectedProduct.name}`
        : 'Movimientos de stock';
    },
    effectiveProductId() {
      return this.selectedProduct ? this.selectedProduct.id : null;
    },
    // id del producto entrante: por prop (route params en memoria) o por query (?productId=),
    // este último permite abrir el movimiento en pestaña nueva con la URL completa.
    incomingProductId() {
      return this.productIdParent || this.$route.query.productId || null;
    },
    movementTypeOptions() {
      return [
        { value: 'all', label: 'Todos' },
        { value: 'in', label: 'Entrada' },
        { value: 'out', label: 'Salida' },
      ];
    },
  },
  created() {
    this.$store.dispatch("categories/getCategories");
    this.$store.dispatch("warehouse/getWarehouses");
    this.$store.dispatch("brands/getBrands");
    this.$store.dispatch("providers/getProviders");
    if (this.incomingProductId) {
      this.fetchAndSelectProduct(this.incomingProductId);
    } else {
      this.getAlertProduct();
    }
  },
  mounted() {
    this.setDefaultDateRange();
    this.checkProductIdParent();
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.isLoading = true; });
      dt.on('xhr.dt', () => { this.isLoading = false; });
    });
  },
  watch: {
    'filters.page': { handler: function () { this.refreshTable(); } },
    'filters.active': { handler: function () { this.refreshTable(); } },
    'filters.itemsPerPage': { handler: function () { this.refreshTable(); } },
    'filters.qname': { handler: function () { this.refreshTable(); } },
    'filters.qcode': { handler: function () { this.refreshTable(); } },
    'filters.qbarcode': { handler: function () { this.refreshTable(); } },
    'filters.qmanufacturercode': { handler: function () { this.refreshTable(); } },
    'filters.qwarehouse': { handler: function () { this.refreshTable(); } },
    'filters.category_id': { handler: function () { this.refreshTable(); } },
    'filters.brand_id': { handler: function () { this.refreshTable(); } },
    'filters.provider_id': { handler: function () { this.refreshTable(); } },
    movement_type() {
      this.refreshTable();
    },
  },
  methods: {
    refreshTable() {
      var vm = this;
      if (vm.suppressReload) return;
      if (vm.$refs.table !== undefined) vm.$refs.table.reload();
    },
    checkProductIdParent() {
      const modal = this.$route.params.modal || this.$route.query.modal;
      if (modal === 'edit') {
        this.isModalVisible = true;
      } else if (modal === 'transfer') {
        this.isModalVisibleTrans = true;
      } else {
        this.isModalVisible = false;
        this.isModalVisibleTrans = false;
      }
      // Si el modal vino por query (pestaña nueva), lo saco de la URL para que un
      // refresh (F5) no lo vuelva a abrir. Mantengo productId para conservar el contexto.
      if (this.$route.query.modal) {
        const query = { ...this.$route.query };
        delete query.modal;
        this.$router.replace({ query }).catch(() => {});
      }
    },
    openModal() {
      this.isModalVisible = true;
    },
    close() {
      this.isModalVisible = false;
      this.isModalVisibleTrans = false;
    },
    openModalTrans() {
      this.isModalVisibleTrans = true;
    },
    modalSucess() {
      this.close();
      this.refreshTable();
    },
    dateUpdated: function (date) {
      this.daterange.fromDate = date.startDate;
      this.daterange.toDate = date.endDate;
      this.refreshTable();
    },
    getAlertProduct() {
      const stored = localStorage.getItem('productId');
      if (!stored) return;
      localStorage.removeItem('productId');
      this.fetchAndSelectProduct(stored);
    },
    fetchAndSelectProduct(id) {
      this.$http.get(`/api/products/getProduct/${id}/1`)
        .then(response => {
          const data = response.data && (response.data.data || response.data);
          const name = (data && data.name) || `Producto #${id}`;
          this.selectedProduct = { id, name };
          this.refreshTable();
        })
        .catch(() => {
          this.selectedProduct = { id, name: `Producto #${id}` };
          this.refreshTable();
        });
    },
    onProductSelected(item) {
      if (!item || !item.id) return;
      this.selectedProduct = { id: item.id, name: item.name };
      this.refreshTable();
    },
    lookupByCode() {
      const value = (this.filters.qcode || '').toString().trim();
      if (!value) return;
      this.$http.get(`/api/products/getProductByCode/${value}/0`)
        .then(response => {
          const data = response.data && (response.data.data || response.data);
          if (data && data.id) {
            this.selectedProduct = { id: data.id, name: data.name };
            this.filters.qcode = '';
            this.refreshTable();
          }
        })
        .catch(() => {});
    },
    lookupByManufacturerCode() {
      const value = (this.filters.qmanufacturercode || '').toString().trim();
      if (!value) return;
      this.$http.post('/api/products/list', { qmanufacturercode: value, page: 1, itemsPerPage: 2 })
        .then(response => {
          const products = response.data && response.data.data && response.data.data.products;
          if (Array.isArray(products) && products.length === 1) {
            const p = products[0];
            this.selectedProduct = { id: p.id, name: p.name };
            this.filters.qmanufacturercode = '';
            this.refreshTable();
          }
        })
        .catch(() => {});
    },
    clearProductFilter() {
      this.selectedProduct = null;
      this.refreshTable();
    },
    setDefaultDateRange() {
      const today = new Date();
      const startDate = new Date();
      startDate.setDate(today.getDate() - 30);

      this.daterange.fromDate = this.formatDate(startDate);
      this.daterange.toDate = this.formatDate(today);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${day}/${month}/${year}`;
    },
    clearFilters() {
      this.suppressReload = true;
      this.filters.provider_id = null;
      this.filters.brand_id = null;
      this.filters.category_id = null;
      this.filters.qwarehouse = null;
      this.filters.active = 1;
      this.movement_type = 'all';
      this.setDefaultDateRange();
      this.daterangeKey++;
      this.$nextTick(() => {
        this.suppressReload = false;
        this.refreshTable();
      });
    },
  },
};
</script>

<style scoped>
.filters-panel__row + .filters-panel__row {
  margin-top: 12px;
}

.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group,
.filters-panel__field--inline > .custom-select {
  flex: 1 1 auto;
  margin-bottom: 0;
}

.filters-panel__field--wide {
  flex: 1 1 220px;
}

/* Override del global _typeahead.scss para alinear el typeahead
   con el resto de los inputs del filters-panel y acotar el dropdown
   al ancho del propio campo. */
::v-deep .filters-panel__field--wide .typeahead__container {
  margin-top: 0;
  position: relative;
}

::v-deep .filters-panel__field--wide .typeahead__container i {
  top: 50%;
  transform: translateY(-50%);
}

::v-deep .filters-panel__field--wide .typeahead__container ul {
  width: 100%;
  min-width: 0;
  max-height: 320px;
  overflow-y: auto;
}
</style>
